import { Button, Grid } from '@material-ui/core';
import React, { useState } from 'react';
import { trackPromise } from 'react-promise-tracker';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { onError, onSuccess } from 'src/store/actions/popupActions';
import axios from '../../axios/AxiosInterceptors';
import useStyles from "../../Styles";
import GeneratorComponent from './GeneratorComponent';


const CreateGenerator = (props) => {

    const classes = useStyles();
    const history = useHistory();
    const params = useParams();
    const dispatch = useDispatch();
    const [generator, setGenerator] = useState({});

    const handleSave = async () => {
        await trackPromise(axios.post("/account-service/v1/account/" + params.accountId + "/generator", JSON.stringify(generator)).then(response => {
            dispatch(onSuccess("Successfully created generator"));
            history.push("/generator-management/account/" + params.accountId + "/generator")
        }).catch(error => {
            dispatch(onError(error.response));
        }));
    }

    const updateGenerator = (generator) => {
        setGenerator({ ...generator });
    }

    return (
        <main className={classes.layout}>
            <GeneratorComponent onChange={updateGenerator} isEdit={true} />
            <Grid container spacing={2}>
                <Grid item xs={6} sm={3} />
                <Grid item xs={6} sm={3}>
                    <Button onClick={() => history.goBack()}>Back</Button>
                </Grid>
                <Grid item xs={6} sm={3} />
                <Grid item xs={6} sm={3}>
                    <Button onClick={handleSave}>Save</Button>
                </Grid>
            </Grid>
        </main>
    )

}

export default CreateGenerator;